import Canvas from "@/components/ui/Canvas";
import { ICanvasProps } from "@/components/ui/Canvas/Models";
import {
  HelpIcon
} from "@/components/ui/Icons/IconsCustom";
import { RootState } from "@/redux";
import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import { Button, Link } from "@fluentui/react-components";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { HeaderTitleWrapper } from "../Styles";
import { HelpContentBaseWrapper } from "./Styles";

export const HelpSetting: React.FC<any> = (props) => {
  const { t } = useTranslation();

  const settingStore: ISettingStore = useSelector(
    (state: RootState) => state.settingInfo
  ) as ISettingStore;

  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const args: ICanvasProps = {
    headerTitle: (
      <HeaderTitleWrapper className="HeaderTitleWrapper">
        <HelpIcon theme={settingStore.theme} />
        <span>{t("Help")}</span>
      </HeaderTitleWrapper>
    ),
    isStickHeader: false,
    isOpen: isOpen,
    onOpen: (isOpen: boolean) => {
      setIsOpen(isOpen);
    },
  };

  return (
    <HelpContentBaseWrapper className="rf-settings-tree-wrapper">
      <Canvas {...args} theme={settingStore.theme || undefined}>
        <div className="rf-settings-content">
          <p>{t("Click on Further information to visit our support site")}</p>
          <div className="wapper-btn">
            <Link href="https://support.add-on.com">
              <Button className="rf-settings-button">{t("More")}</Button>
            </Link>
          </div>
        </div>
      </Canvas>
    </HelpContentBaseWrapper>
  );
};
